import { QUIZ_CONSTANTS } from './constants';
import { validateProduct } from './quizResults';
import { optionsToProductMapping } from './quizStaticMapping';
import { extend, remove } from 'lodash';

const generateProductsWithDev = (steps, tools) => {
  return intersectProducts(steps, tools);
};

//Intersect steps 3 and 4 products
const intersectProducts = (steps, tools) => {
  let intersectedProducts = [];

  let stepThreeOptions = steps[3],
    stepFourOptions = steps[4][0],
    productsToIntersectWith = optionsToProductMapping[stepFourOptions];

  stepThreeOptions.forEach(option => {
    let products = optionsToProductMapping[option];
    products.forEach(product => {
      if (productsToIntersectWith.includes(product))
        intersectedProducts.push(product);
    });
  });

  return union(steps, intersectedProducts, tools);
};

//Union the above intersection with step 2 products
const union = (steps, intersectedProducts, tools) => {
  let unionProducts = [...intersectedProducts];
  steps[2].forEach(option => {
    let productsForOption = optionsToProductMapping[option];
    productsForOption.forEach(product => {
      if (!unionProducts.includes(product)) {
        unionProducts.push(product);
      }
    });
  });
  return retrieveProductTypes(steps, unionProducts, tools);
};

const validateDev = ({ developer, product, extras }) =>
  optionsToProductMapping.developer.includes(product) &&
  !developer.includes(product) &&
  !extras.includes(product);

const validateExtras = ({ extras, product }) =>
  optionsToProductMapping.extras.includes(product) && !extras.includes(product);

const validateUsers = ({ user, product, extras, developer }) =>
  !user.includes(product) &&
  !extras.includes(product) &&
  !developer.includes(product);

//Create final user, developer, and extra products to show on the quiz results page
const retrieveProductTypes = (steps, finalProducts, tools) => {
  let user = [],
    extras = [],
    developer = [],
    res = {},
    isDeveloper = steps[4].includes(QUIZ_CONSTANTS.developer);
  finalProducts.forEach(product => {
    let isValidProduct = validateProduct(tools, product);
    if (isValidProduct) {
      if (validateExtras({ extras, product })) {
        extras.push(product);
      }
      if (isDeveloper && validateDev({ developer, product, extras })) {
        developer.push(product);
      }
      if (validateUsers({ user, product, extras, developer })) {
        user.push(product);
      }
    }
  });

  extend(res, { user, extras });
  if (isDeveloper) {
    remove(extras, product => product === 'addDeveloper');
    extend(res, { developer });
  }
  return res;
};

export { generateProductsWithDev };
